import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'environments/environment';
import { ToastrService } from 'ngx-toastr';
import { interval, Observable, switchMap } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class NotificationService {

  constructor(private httpClient: HttpClient, private toastr: ToastrService) { }
  private apiUrl = environment.apiUrl;
  getNotificationList(userId:number,name:any,page:any,pageSize:any): Observable<any> {
    return this.httpClient.get(`${this.apiUrl}/Notification/GetNotificationList?userId=${userId}&name=${name}&page=${page}&pageSize=${pageSize}`).pipe(
      //catchError(this.error)
    );;
  }
  getTopNotifications(userId: number): Observable<any> {    
    return this.httpClient.get(
      `${this.apiUrl}/Notification/GetHeaderNotification?userId=${userId}`
    );
  }
  getNotificationById(id: number): Observable<any> {
    return this.httpClient.get(`${this.apiUrl}/Notification/GetNotificationById?id=${id}`).pipe(
      //catchError(this.error)
    );
  }
  updateNotification(notification: any): Observable<any> {
    return this.httpClient.post(`${this.apiUrl}/Notification/UpdateNotification`,notification).pipe(
      //catchError(this.error)
    );
  }
  getHeaderNotification(userid: number): Observable<any> {
    return this.httpClient.get(`${this.apiUrl}/Notification/GetHeaderNotification?userId=${userid}`).pipe(
      //catchError(this.error)
    );
  }
  
  

  // Polling service to fetch notifications periodically
  pollNotifications(userId: number, intervalTime: number): Observable<any> {
    return interval(intervalTime).pipe(
      switchMap(() => this.getTopNotifications(userId))
    );
  }
}
